module.exports = __webpack_public_path__ + "img/guide.d5df6454.png";